import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import loadable from '@loadable/component';

import routers from '../pages/page-routes';
import PageLoading from '../layouts/page-loading/PageLoading';
import { isXlm, xlmReady } from '../utils/bridge';
import ErrorPage from '../pages/error-page/ErrorPage';

const NO_XLM_READY_PATHS = ['/esign/callback'];

const shouldWaitXlmReady = () => isXlm && !NO_XLM_READY_PATHS.includes(window.location.pathname);

class AppRouter extends React.Component {
  state = {
    ready: false,
    error: false,
  };

  componentDidMount() {
    if (!shouldWaitXlmReady()) {
      this.setState({ ready: true });
      return;
    }
    xlmReady(() => {
      this.setState({ ready: true });
    });
  }

  componentDidCatch() {
    this.setState({ error: true });
  }

  render() {
    const { ready, error } = this.state;
    if (!ready && shouldWaitXlmReady()) return <PageLoading />;

    if (error) return <ErrorPage error />;
    return (
      <BrowserRouter>
        <Switch>
          {routers.map((item, index) => {
            return (
              <Route
                key={index}
                path={item.path}
                exact
                component={loadable(item.component, { fallback: <PageLoading /> })}
              />
            );
          })}
          <Route component={ErrorPage} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default AppRouter;
